export default __webpack_public_path__ + "static/media/slider-1.33ae1c46.png";